import { Alignment, Direction, Displaying, palette, Positioning, Spacing } from "@bonusx-global/bx-design-system";
import type { IWithIsMobile } from "@bonusx-global/bx-design-system/dist/types/interfaces";
import { Global } from "@emotion/react";
import styled from "@emotion/styled";
import CssBaseline from "@mui/material/CssBaseline";
import type { PropsWithChildren } from "react";
import useIsMobile from "../../../../hooks/device/useIsMobile";
import { zIndexes } from "../../../../R";
import { Modal } from "../../../components/poppers/Modal";
import { BonusXThemeProvider } from "../../../theme/BonusXThemeProvider";
import { MOBILE_WRAPPER_INNER_PADDING, WRAPPER_INNER_PADDING } from "../../../theme/style.constants";

const SignatureSettingsBodyContainer = styled("div")<IWithIsMobile>(({ isMobile }) => ({
  display: Displaying.flex,
  padding: isMobile ? MOBILE_WRAPPER_INNER_PADDING : WRAPPER_INNER_PADDING,
  flexDirection: Direction.column,
  alignItems: Alignment.center,
  gap: Spacing["0"],
  flex: "1 0 0",
  alignSelf: Alignment.stretch,
}));

const HeaderContainer = styled.div`
  display: ${Displaying.block};
  position: ${Positioning.sticky};
  top: ${Spacing["0"]};
  z-index: ${zIndexes.one_thousand};
`;

const globalStyles = ` 
  body {
    background-color: ${palette?.background?.default} !important;
  }
`;

export interface ISignatureSettingsLayoutProps {
  readonly header: React.ReactNode;
}

export function SignatureSettingsLayout({
  children,
  header,
}: PropsWithChildren<ISignatureSettingsLayoutProps>): JSX.Element {
  const isMobile = useIsMobile();

  return (
    <BonusXThemeProvider>
      <CssBaseline />
      <Global styles={globalStyles} />
      <Modal />
      <HeaderContainer>{header}</HeaderContainer>
      <SignatureSettingsBodyContainer isMobile={isMobile}>{children}</SignatureSettingsBodyContainer>
    </BonusXThemeProvider>
  );
}
